import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { constructQueryParams } from 'utils/query-params-builder';
import { ResponseCityDto } from '../types/dtos';

export type CitiesQueryParams = BaseQueryParams;

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<PaginatedResponse<ResponseCityDto>, CitiesQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const citiesResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.CITIES, _arg));

            if (citiesResponse.error) {
                return { error: citiesResponse.error };
            }

            const cities = citiesResponse.data as PaginatedResponse<ResponseCityDto>;

            return {
                data: cities,
            };
        },
        providesTags: [{ type: 'cities', id: 'GET' }],
    });
